(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/overflow-observer
 * -----------------------------------------------------------------------------
 * @version 0.0.5
 * @overview Child content overflow observer.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("overflow-observer") === undefined) {
    class overflowObserver extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            new ResizeObserver(this.resizeEvent.bind(this)).observe(this);
        }
        resizeEvent() {
            this.scrollWidth > this.offsetWidth ? this.classList.add("overflow-observer-overflows") : this.classList.remove("overflow-observer-overflows");
        }
    }
    customElements.define("overflow-observer", overflowObserver);
}



})();
